<template>
  <div class="contact_warp">
    <el-form>
      <el-row gutter="20">
        <el-col span="6">
          <el-input v-model="userName" placeholder="姓名" clearable/>
        </el-col>
        <el-col span="6">
          <el-input v-model="phoneNum" placeholder="手机" clearable />
        </el-col>
        <el-col span="6">
          <el-input v-model="age" placeholder="年龄" type="number" clearable />
        </el-col>
        <el-col span="6">
          <el-button 
            type="primary" 
            style="width: 100%; background-color: #ff914E; color: black;" 
            @click="submitConsultation"
          >
            立即咨询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      userName: '',
      phoneNum: '',
      age: null,
      imgList: [],
    }
  },
  methods: {
    async submitConsultation() {
      // 表单验证
      if (!this.userName || !this.userName.trim()) {
        this.$message.warning('请输入姓名')
        return
      }
      if (!this.phoneNum || !this.phoneNum.trim()) {
        this.$message.warning('请输入手机号')
        return
      }
      // 手机号格式验证
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(this.phoneNum)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      if (!this.age) {
        this.$message.warning('请输入年龄')
        return
      }

      try {
        const response = await axios.post(
          'https://bearms.xyusk.cn/prod-api/data/cluesData',
          {
            userName: this.userName.trim(),
            phoneNum: this.phoneNum.trim(),
            age: Number(this.age)
          }
        )

        if (response.data.code === 200 || response.data.success) {
          this.$message.success('提交成功！我们会尽快与您联系')
          // 清空表单
          this.userName = ''
          this.phoneNum = ''
          this.age = null
        } else {
          this.$message.error(response.data.message || '提交失败，请重试')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error('网络错误，请稍后重试')
      }
    }
  }
}
</script>

<style lang="scss">
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
    .font-style {
      font-family: "Open Sans", Raleway, Arial, Verdana, Helvetica, 'Microsoft Yahei', Lato, sans-serif;
      font-size: 38px;
    }
  }
}

.contact_warp {
  display: flex;
  height: 85px;
  background-color: #003366;
  align-items: center;
  justify-content: center;
  el-col{
    margin-bottom: 18px;
  }
}
</style>